import React from 'react';

class AddSkill extends React.Component {

  handleClick = (event) => {
    event.preventDefault();

    const skill = {
      name: document.getElementById('addskill-newskill-name').value,
      icon: document.getElementById('addskill-newskill-icon').value,
      link: document.getElementById('addskill-newskill-link').value
    };

    this.props.addSkill(skill);
    document.getElementById('addskill-newskill-name').value = "";
    document.getElementById('addskill-newskill-icon').value = "";
    document.getElementById('addskill-newskill-link').value = "";
  }

  render() {
    return (
      <form className="updateDetails-main-addSkill">
        <h1>Add Skill</h1>
        <span>Name: </span><input type="text" placeholder="Skill Name" id="addskill-newskill-name" />
        <span>Icon: </span><input type="text" placeholder="Skill Icon" id="addskill-newskill-icon" />
        <span>Link: </span><input type="text" placeholder="Skill Name" id="addskill-newskill-link" /><br />
        <button onClick={this.handleClick}>+ Add skill</button>
      </form>
    );
  }
}

export default AddSkill;
